/**
 * GreenSign color palette — single source of truth for JS/TS (inline styles, third-party APIs).
 * CSS uses matching tokens in :root (globals.css). Keep both in sync.
 */
export const COLORS = {
  /* Brand */
  primary: "#34a853",
  primaryHover: "#2ca04b",
  primaryHoverAlt: "#2d9248",
  primaryLight: "#71e086",
  primaryTint: "#f0faf3",
  primaryMutedBg: "#eef0ff",
  primaryMutedBorder: "#c1c8ff",
  primaryBadgeBg: "#dbfbe8e6",

  /* Surfaces */
  white: "#ffffff",
  background: "#f5f6fa",
  surfaceHover: "#ebeef2",
  surfaceSubtle: "#eceff3",
  surfaceNeutral: "#f4f4f4",
  lightBg: "#f8f9fa",
  skeleton: "#e6e8eb",
  footerBg: "#eaeaea",

  /* Text */
  foreground: "#526484",
  cardForeground: "#364a63",
  secondary: "#1c2b46",
  label: "#344357",
  textMutedAlt: "#3c4d62",
  mutedForeground: "#8094ae",
  icon: "#7986ae",
  textDark: "#333333",
  textMutedLong: "#666666",
  black: "#000000",

  /* Borders */
  border: "#dbdfea",
  muted: "#e5e9f2",
  borderNeutral: "#dde1eb",
  inputDefault: "#ced4da",
  gray: "#cccccc",
  grayLight: "#cfcfcf",

  /* Semantic */
  destructive: "#e85347",
  destructiveHover: "#d14a3f",
  success: "#1ee0ac",
  successBg: "#e6fcf6",
  successBorder: "#a5f3de",
  successAlt: "#4caf50",
  successTint: "#ddffdd",
  warning: "#fbc71e",
  warningAlt: "#f1c40f",
  warningText: "#2a230c",
  warningTint: "#fffae6",
  warningSurface: "#fef8e4",
  warningBorder: "#fbe59f",
  warningIcon: "#f4bd0e",
  info: "#3498db",
  infoBg: "#ddf2ff",
  infoTint: "#e7f3ff",
  link: "#007bff",
  linkBrand: "#2463d1",
  disabled: "#e9ecef",

  /* Audit log category badges */
  categoryBeigeBg: "#e9ebee",
  categoryBeigeText: "#364a63",
  categoryBeigeBorder: "#afb7c1",
  categoryInfoBg: "#e4f8fb",
  categoryInfoText: "#09c2de",
  categoryInfoBorder: "#9de7f2",

  /* Theme / email preview defaults */
  emailHeaderText: "#efebea",
  emailButton: "#ffc423",
} as const;

export type ColorToken = keyof typeof COLORS;

/** Default brand theme colors (Add Brand / Create Theme) */
export const DEFAULT_THEME_COLORS = {
  headerBg: COLORS.primary,
  headerText: COLORS.emailHeaderText,
  buttonBg: COLORS.warning,
  buttonText: COLORS.warningText,
} as const;
